import React from 'react';
import {Typography} from '@material-ui/core';
import {FormattedMessage, useIntl} from 'react-intl';
import Title from 'components/Title';
import Content from 'components/Content';
import {Helmet} from 'react-helmet-async';
import useStyles from './PrivacyPolicyPage.styles';

export default function () {
    let classes = useStyles();
    let intl = useIntl();

    return (
        <div className={classes['root']}>
            <Helmet>
                <title>
                    {intl.formatMessage({
                        id: 'meta.PrivacyPolicyPage.title',
                    })}
                </title>
                <meta
                    name="description"
                    content={intl.formatMessage({
                        id: 'meta.PrivacyPolicyPage.description',
                    })}
                />
            </Helmet>
            <Title
                title={
                    <FormattedMessage
                        id="pages.PrivacyPolicyPage.pageTitle"
                        defaultMessage={`Privacy Policy`}
                    />
                }
            />
            <Content component="article">
                <Typography
                    variant="body2"
                    component="p"
                >
                    <strong>
                        Through its websites Direct Basing® B.V. will process privacy-sensitive or personal data. Direct
                        Basing B.V. values the privacy of its customers and observes due care in processing and protecting
                        personal data.
                    </strong>
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We process data in compliance with the requirements laid down by the Dutch Personal Data Protection Act (DPDA).
                    Direct Basing® B.V. is the party responsible for all data processing. In this privacy statement, we will explain which
                    personal data we collect and for which purposes. We recommend that you read it carefully.
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    This privacy statement was last amended on 20-12-2014.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Use of Personal Data
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    By using our service, you are providing certain data to us. This could be personal data. We only retain and use the
                    personal data provided directly by you or for which it is clear that it has been supplied to us to be processed.
                    Although companies can make use of our website, company data is not covered by the DPDA. This privacy statement is
                    primarily directed to those using the website as a private person or as an employee.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Contact Form and Newsletter
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We have a newsletter to inform those interested of our products and/or services. Your email address will be added to
                    the list of subscribers automatically. Each newsletter contains a link with which to unsubscribe from our
                    newsletter.
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    If you fill out a contact form on the website or send us an email, the data you provide will be retained for as long
                    as is necessary depending on the nature of the form or the content of your email, to fully answer and correctly
                    handle your message or email. We collect your:
                </Typography>
                <ul>
                    <li>
                        <Typography variant="body2">
                            Name and address
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            Email address
                        </Typography>
                    </li>
                </ul>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We may contact you for commercial purposes by email.
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    Each individual message offers you the opportunity to unsubscribe. If necessary, we may collect your location data
                    (GPS). If that is the case, you will be asked to grant consent beforehand. This location data and other data can also
                    be stored and processed by the provider of the navigation/mapping software, such as Google Maps, but the data could
                    also be used by for example Google or Apple itself. We have no control over their actions. We recommend that you read
                    the applicable privacy statement of the provider in question.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Advertisements
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    Our service collects personal data for advertisement opportunities for the Direct Basing® Network. For this the
                    following personal data are used:
                </Typography>
                <ul>
                    <li>
                        <Typography variant="body2">
                            Any other automatically collected (supposed) interests
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            The paths by which you navigate through our service
                        </Typography>
                    </li>
                </ul>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Providing Data to Third Parties
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We may provide your data to our partners. These partners are involved in the execution of the agreement. This
                    concerns the following personal data:
                </Typography>
                <ul>
                    <li>
                        <Typography variant="body2">
                            Your name and address
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            Your email address
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            The paths by which you navigate through our service
                        </Typography>
                    </li>
                </ul>
                <Typography
                    variant="body2"
                    component="p"
                >
                    These partners may be based outside the EU. However, they are safe harbour certified.
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    Our website features social media buttons. These buttons are used by the providers of these services to collect your
                    personal data.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Security
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We take security measures to reduce misuse of and unauthorised access to personal data. We take the following
                    measures in particular:
                </Typography>
                <ul>
                    <li>
                        <Typography variant="body2">
                            Access to personal data requires the use of a user name and password
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            Access to personal data requires the use of a user name and login token
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            We make use of secure connections (Secure Sockets Layer of SSL) to encrypt all information between you and our
                            website when entering your personal data
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body2">
                            We keep logs of all requests for personal data
                        </Typography>
                    </li>
                </ul>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We do keep statistics on our website, giving us access to individual data. However, we only access individual data
                    insofar as necessary for the purposes set out in this statement.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Third-party Websites
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    This statement is not applicable to third-party websites connected to this website through links. We cannot guarantee
                    that these third parties will handle your personal data in a secure and careful manner. We recommend you read these
                    websites privacy statements before making use of these websites.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Changes to this Privacy Statement
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    We reserve the right to modify this statement. We recommend that you review this statement regularly, so that you
                    remain informed of any changes.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Inspection and Modification of your Data
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    You can always contact us if you have any questions regarding our privacy policy or wish to review, modify or delete
                    your personal data.
                </Typography>
            </Content>
        </div>
    );
}
